import api from './api';

export const siniestrosService = {

  listar: (page = 0, size = 25) =>
    api.get('/siniestros', { params: { page, size } }),

  buscar: (tipo, valor, page = 0, size = 25) =>
    api.get('/siniestros/buscar', { params: { tipo, valor, page, size } }),

  pendientes: (desde, hasta, page = 0, size = 25) =>
    api.get('/siniestros/pendientes', { params: { desde, hasta, page, size } }),

  obtener: (id) =>
    api.get(`/siniestros/${id}`),

  extensiones: (id) =>
    api.get(`/siniestros/${id}/extensiones`),

  crear: (data) =>
    api.post('/siniestros', data),

  actualizar: (id, data) =>
    api.put(`/siniestros/${id}`, data),

  anular: (id, fechaAnulacion) =>
    api.delete(`/siniestros/${id}`, { data: { fechaAnulacion } }),

  crearExtension: (id) =>
    api.post(`/siniestros/${id}/extension`),

  emitir:    (id) => api.post(`/siniestros/${id}/emitir`),
  confirmar: (id) => api.post(`/siniestros/${id}/confirmar`),

  existeNSiniestro: (valor, excluirId) =>
    api.get('/siniestros/existe-n-siniestro', { params: { valor, excluirId } }),

  existeCodPoliza: (valor, excluirId) =>
    api.get('/siniestros/existe-poliza', { params: { valor, excluirId } }),

  informe: (params = {}) =>
    api.get('/siniestros/informe', { params }),

  stats: () =>
    api.get('/siniestros/stats'),
};
